window.Vue = require("vue");

import VueLazyImageLoading from 'vue-lazy-image-loading'
import VueResource from "vue-resource";
import VueTextareaAutosize from "vue-textarea-autosize";
import AOS from 'aos';
import KsVueScrollmagic from 'ks-vue-scrollmagic';
import AccordionContent from "./components/AccordionContent.vue";
import AccordionFilter from "./components/AccordionFilter.vue";
import TextInput from "./components/TextInput.vue";
import FormHandler from "./components/FormHandler.vue";
//import GoogleMap from "./components/GoogleMap.vue";
import TestimonialSlider from "./components/TestimonialSlider.vue";
import BrandsSlider from "./components/BrandsSlider.vue";
import MarqueeText from "./components/Marquee.vue";
import NewsPicker from "./components/NewsPicker.vue";
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import LinkedInButton from "vue-share-buttons/src/components/LinkedInButton";


Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.use(VueLazyImageLoading)
Vue.use(VueTextareaAutosize);
Vue.use(VueResource);
Vue.use(KsVueScrollmagic);

new Vue({
    data() {
        return {
            isPageReady: false,
            isShowingMenu: false,
            isShowingSearch: false,
            isScrolled: false,
            topScrollThreshold: 40,
        };
    },
    components: {
        TextInput,
        AccordionContent,
        AccordionFilter,
        FormHandler,
        TestimonialSlider,
        BrandsSlider,
        MarqueeText,
        NewsPicker,
        TwitterButton,
        FacebookButton,
        LinkedInButton,

    },
    watch: {
        // isShowingMenu: function (newValue, oldValue) {
        //     document.body.style.overflow = newValue == true ? "hidden" : "auto";
        // },
    },
    methods: {
        didScroll() {
            this.isScrolled = window.scrollY > this.topScrollThreshold;
        },
        toggleMenu() {
            this.isShowingMenu = !this.isShowingMenu;
        },
        toggleSearch() {
            this.isShowingSearch = !this.isShowingSearch;
        },

        pinContainerScene() {
      
            if (typeof this.$refs.panel === "undefined") {
                return;
              }

            const tl = new this.$gsap.TimelineMax();

            let animFrom = {
                left: "0"
            };

            let scrollDistance =
                this.$refs.panel.clientWidth - this.$refs.pin.clientWidth;

            tl.fromTo(`div.panel`, 2, animFrom, {
                left: -scrollDistance,
                ease: Linear.easeNone
            });

            const scene = new this.$scrollmagic.Scene({
                    triggerElement: ".pinContainer",
                    triggerHook: 0,
                    duration: scrollDistance 
                })
                .setPin(".pinContainer")
                .setTween(tl);

            this.$ksvuescr.$emit("addScene", "pinContainerScene", scene);
        
            
        }
    },
    created() {
        window.addEventListener("scroll", this.didScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.didScroll);
    },

    mounted() {
        var self = this;

        AOS.init();

        window.addEventListener("click", this.onClick);

        setTimeout(function () {
            self.isPageReady = true;
        }, 500);

        this.$nextTick(this.pinContainerScene);
    },

    destroyed() {
        this.$ksvuescr.$emit("destroy");
    },
}).$mount("#app");
